import React, { useEffect } from "react";
import "./New_In_Store.css";
import Common_Heading_Holder from "../../common_components/common_heading_holder/Common_Heading_Holder";
import Store_Product_Card from "./store_product_card/Store_Product_Card";
import New_Lottie from "../../animation/new_lottie/New_Lottie";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllProductsNewLaunch,
  getAllProductsSeasonable,
} from "../../../features/products/productsSlice";

const New_In_Store = ({ product }) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const data = [
    {
      name: "Beverages",
      img: "/assets/images/products/img1.png",
      discount: 10,
    },
    {
      name: "Noodels and Pasta",
      img: "/assets/images/products/img2.png",
    },
    {
      name: "Beverages",
      img: "/assets/images/products/img3.png",
      discount: 10,
    },
    {
      name: "Coffee & Tea",
      img: "/assets/images/products/img4.png",
      discount: 10,
    },
    {
      name: "Ice Cream and Frozen Desserts",
      img: "/assets/images/products/img5.png",
    },
    {
      name: "Coffee & Tea",
      img: "/assets/images/products/img5.png",
    },
  ];

  const seasonableProduct = useSelector(
    (state) => state.product.allProductsSeasonable
  );

  useEffect(() => {
    dispatch(getAllProductsSeasonable({}));
  }, [dispatch]);

  return (
    <section className="New_In_Store">
      <div className="new_lottie_div">
        <New_Lottie />
      </div>

      <Common_Heading_Holder
        headingText={"New In Store"}
        viewShowAllButton
        goto="/all-products"
      />

      <div className="main_content_div">
        <div className="row">
          <div className="col-xxl-5 col-md-4">
            <div className="main_img_div">
              <Store_Product_Card
                product={seasonableProduct?.[0]}
                img={"/assets/images/home/new_in_store/img1.png"}
                name={"Chips"}
              />
            </div>
          </div>

          <div className="col-xxl-7 col-md-8">
            <div className="grid_view_div">
              {/* 
                            {seasonableProduct?.map((product) => {
                                return (
                                    // <Store_Product_Card img={item?.img} name={item?.name} discount={item?.discount} />
                                    <Store_Product_Card product={product}/>
                                )
                            })} */}

              {seasonableProduct?.slice(1,7).map((product, index) => (
                <Store_Product_Card key={index} product={product} />
              ))}

              {/* {seasonableProduct?.map((product) => {
                return (
                  // <Store_Product_Card img={item?.img} name={item?.name} discount={item?.discount} />
                  <Store_Product_Card product={product} />
                );
              })} */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default New_In_Store;
